import JSZip from 'jszip';
import {saveAs} from 'file-saver';
import Config from '../core/config';
import {makeRequest} from './httpRequest';

// O sb-printer lê o sb-printer.properties da mesma pasta do jar (ou do sb-printer.exe).
// printerServerUrl no config.json diz onde o printer acessa a API e os websockets.
// Sem cache: uma cópia antiga do config.json já gerou properties com o servidor errado.
async function loadPrinterServerUrl() {
    const response = await fetch(process.env.PUBLIC_URL + '/config.json', {cache: 'no-store'});
    const config = await response.json();
    return config.printerServerUrl || config.apiUrl;
}

function toWebSocketUrl(url) {
    return url.replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://');
}

function buildProperties(serverUrl, companyUuid) {
    return [
        '# Configuracao do SB Printer. Este arquivo e a unica fonte usada para imprimir.',
        '# Gerado pelo site em ' + new Date().toLocaleString('pt-BR'),
        'printerName=',
        'urlApi=' + serverUrl,
        'urlWebSocket=' + toWebSocketUrl(serverUrl),
        'companyUuid=' + companyUuid,
        'printType=PRINT_SALES,PRINT_BILLS',
        'orderType=MESA,COMANDA',
        'salesPrintType=PRINT_ITEMS_TOGETHER',
        'interval=1',
        'pollSleep=5',
        'enableLog=true',
        'printToFiles=false',
        '',
    ].join('\n');
}

// O printer imprime os pedidos da empresa, identificada pelo UUID do cadastro de empresas.
async function loadCompanyUuid() {
    const response = await makeRequest(Config.apiUrl + '/api/companies/printer-uuid', 'GET', {});
    if (!response || !response.uuid) {
        throw new Error('Empresa não identificada.');
    }
    return response.uuid;
}

async function fetchDownload(fileName) {
    const response = await fetch(process.env.PUBLIC_URL + '/downloads/' + fileName);
    if (!response.ok) {
        throw new Error('Não foi possível baixar o ' + fileName + ' (' + response.status + ').');
    }
    return response.arrayBuffer();
}

// O sb-printer-windows.zip (gerado pelo package-windows.sh do sb-printer) já traz a pasta sb-printer
// com o sb-printer.exe do jpackage; o jar e o properties entram na mesma pasta, ao lado do .exe.
export async function downloadSbPrinter() {
    const [companyUuid, serverUrl, jar, windowsImage] = await Promise.all([
        loadCompanyUuid(),
        loadPrinterServerUrl(),
        fetchDownload('sb-printer.jar'),
        fetchDownload('sb-printer-windows.zip'),
    ]);

    const zip = await JSZip.loadAsync(windowsImage);
    const folder = zip.folder('sb-printer');
    folder.file('sb-printer.jar', jar);
    folder.file('sb-printer.properties', buildProperties(serverUrl, companyUuid));

    const content = await zip.generateAsync({type: 'blob', compression: 'DEFLATE'});
    saveAs(content, 'sb-printer.zip');
}
